import React from 'react'
import { CreditApplication } from '_gql'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'

import { StatusButtons } from '@sputnik/components'
import ImageWrapper from '@sputnik/components/ImageWrapper/ImageWrapper'
import { getPaymentNetwork } from '@sputnik/components/utils'
import StatusTile from '@sputnik/pages/Dashboard/StatusTile/StatusTile'
import { PATHNAME_CONSTS, PRODUCT_CONST_STRINGS } from '@sputnik/resources/constants'

interface MigrationInProgressStatusTileProps {
  creditApp: CreditApplication
}

const MigrationInProgressStatusTile = ({ creditApp }: MigrationInProgressStatusTileProps) => {
  const { salesforceCreditId, dsaVersion } = creditApp || {}
  const { BILL_SPEND_AND_EXPENSE } = PRODUCT_CONST_STRINGS

  const paymentNetwork = getPaymentNetwork(dsaVersion)

  const [makeTestId] = useNameFormatter('MigrationInProgressStatusTile')
  return (
    <div data-testid={makeTestId('')}>
      <StatusTile
        creditApp={creditApp}
        image={
          <ImageWrapper
            alt='finger tapping on a card'
            imageName='dashboard-application-migration-action-needed-status'
          />
        }
        primaryInfo={
          <FormattedMessage
            defaultMessage="We've started the process to migrate your {BILL_SPEND_AND_EXPENSE} account to {paymentNetwork}. All you have to do is review and update the information we have on file for accuracy."
            id='sputnik.MigrationInProgressStatusTile__iOazZg'
            values={{ BILL_SPEND_AND_EXPENSE, paymentNetwork }}
          />
        }
        title={
          <FormattedMessage
            defaultMessage='Review your {paymentNetwork} application'
            id='sputnik.MigrationInProgressStatusTile__+rH0M0'
            values={{ paymentNetwork }}
          />
        }
      >
        <StatusButtons
          hideSecondary
          primaryPath={`/app/${salesforceCreditId}/${PATHNAME_CONSTS.REVIEW_PATH}`}
          primaryText={
            <FormattedMessage
              defaultMessage='Review application'
              id='sputnik.MigrationInProgressStatusTile__lB/ra7'
            />
          }
        />
      </StatusTile>
    </div>
  )
}

export default MigrationInProgressStatusTile
